import React from 'react';
import { Typography, TypographyProps, Skeleton } from '@mui/material';

interface LoadingTypographyProps extends TypographyProps {
    loading?: boolean;
    width?: number;
}

export const LoadingTypography: React.FC<React.PropsWithChildren<LoadingTypographyProps>> = ({
    loading,
    width,
    className,
    ...props
}) => {
    if (loading) {
        return <Skeleton className={className} variant="text" width={width} />;
    }
    return <Typography className={className} {...props} />;
};
